import React from "react";
import { useTranslation } from "react-i18next";
import { StyledModal, StyledLabel, CheckboxIcon } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { capitalize } from "@helpers/general";
import { toast } from "react-toastify";
import { useSnapshot } from "valtio";
import { mutate } from "swr";
import { uuid } from "uuidv4";
import { setCanValidate, setIsLoading, setKey } from "../store";
import { store } from "@components/VerticalLayout/store";
import { useFetchGlobal } from "../../../../api/hooks";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { ID_SALE_SUPPORT_KIOSK } from "@constants/index";
import { getDifferenceOfSaleMethodItemsInInformationMode } from "../helper";

type ConfirmationModificationMessageType = {
    isModalOpened: boolean;
    setIsModalOpened: Function;
    setIsEdited: Function;
    setDataIsUpdated: Function;
    dataModeInformation: any;
    associated: any;
    setIsSendingTag: Function;
    dataTable?: any;
    setIsAddModeOfInformationClicked: Function;
    setLimit: Function;
    KIOSKData: any;
};

export function ConfirmationModificationMessage({
    isModalOpened,
    setIsModalOpened,
    setIsEdited,
    setDataIsUpdated,
    dataModeInformation,
    associated,
    setIsSendingTag,
    dataTable,
    setIsAddModeOfInformationClicked,
    setLimit,
    KIOSKData,
}: ConfirmationModificationMessageType) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();
    const { userID, franchiseID, operatorID } = useSnapshot(store);
    const uuidUser = localStorage.getItem("uuidUser");

    async function editModeOfInformation(isValidation: boolean) {
        setIsLoading(true);
        toast.dismiss();
        let dataConfig: any[] = [dataModeInformation];

        let updatedKIOSKData: any = KIOSKData;
        if (isValidation === true) {
            for (let index = 0; index < associated.length; index++) {
                const el = associated[index];
                let idShop = Array.isArray(el.shopId)
                    ? el.shopId[0]
                    : el.shopId;
                if (idShop !== 0) {
                    if (el.Id !== undefined) {
                        dataConfig.push({
                            userId: userID,
                            shopId: [idShop],
                            franchiseId: franchiseID,
                            operatorId: operatorID,
                            uuidUser: uuidUser,
                            data: {
                                [el.Id]: {
                                    designation:
                                        dataModeInformation.data[el.Id]
                                            .designation,
                                    idMI: dataModeInformation.data[el.Id]?.idMI,

                                    supportOfSale:
                                        dataModeInformation.data[el.Id]
                                            .supportOfSale,
                                    salesSupportData:
                                        dataModeInformation.data[el.Id]
                                            .salesSupportData,
                                    modeOfSale:
                                        dataModeInformation.data[el.Id]
                                            .modeOfSale,
                                    displayName:
                                        dataModeInformation.data[el.Id]
                                            .displayName,
                                    tag: dataModeInformation.data[el.Id].tag,
                                    isArchived: el.isArchived,
                                    shopId: idShop,
                                    state: el.state,
                                    stateShop: true,
                                    advancedDisplayName:
                                        dataModeInformation.data[el.Id]
                                            .advancedDisplayName,
                                },
                            },
                        });

                        if (
                            dataModeInformation.data[el.Id].supportOfSale
                                .value === ID_SALE_SUPPORT_KIOSK
                        ) {
                            let oldData = {
                                modeOfSale: el[t("Sales method")],
                                advancedDisplayName: el.advancedDisplayName,
                            };

                            updatedKIOSKData = getDifferenceOfSaleMethodItemsInInformationMode(
                                oldData,
                                {
                                    modeOfSale:
                                        dataModeInformation.data[el.Id]
                                            .modeOfSale,
                                    advancedDisplayName:
                                        dataModeInformation.data[el.Id]
                                            .advancedDisplayName,
                                }
                            );
                        }
                    }
                }
            }
        }
        if (dataConfig.length > 0) {
            try {
                const response: any = await fetchGlobal(
                    `${process.env.REACT_APP_API_V2_URL}/settings/general/mode_of_Information`,
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            dataConfig,
                            updatedKIOSKData,
                        }),
                    }
                );
                mutate(
                    `${process.env.REACT_APP_API_V2_URL}/settings/general/mode_of_Information`,
                    response
                );
                if (response.error === false) {
                    toast.success(
                        `${t(
                            "The shop(s) mode of information has been successfully changed"
                        )!}`,
                        {
                            position: toast.POSITION.TOP_CENTER,
                            theme: "colored",
                            icon: (
                                <CheckboxIcon
                                    height={25}
                                    width={25}
                                    fill="white"
                                />
                            ),
                        }
                    );
                }
                if (response.blockAssign === true) {
                    setLimit(2);
                    toast.warn(
                        t(
                            "Please note that the assignment could not be made to one or more stores. Please check the store(s) data settings."
                        ),
                        {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 2000,
                            theme: "colored",
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        }
                    );
                }
            } catch (e) {
                toast.error(`${t("There's an error")!}`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }

            setIsSendingTag(true);
            setKey(uuid());
            setIsAddModeOfInformationClicked(false);
            setIsEdited(false);
            setIsLoading(false);
        }
    }

    return (
        <StyledModal toggle={true} isOpen={isModalOpened!} centered>
            <ModalHeader
                className="text-capitalize"
                toggle={() => {
                    setIsModalOpened(!isModalOpened);
                    setCanValidate(true);
                }}
            >
                <span
                    style={{
                        fontFamily: "Segoe UI Semibold",
                        color: "#2b2828",
                        fontSize: "20px",
                    }}
                >
                    {capitalize(t("Alert"))}
                </span>
            </ModalHeader>
            <ModalBody>
                <StyledLabel
                    className="pl-3 m-0"
                    style={{ whiteSpace: "pre-line" }}
                >
                    {t(
                        'Do you want to apply these changes for all stores? \n Attention ! If you click on "Validate", the specific settings of the shops will be modified.'
                    )}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0 ">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={() => {
                        setCanValidate(true);
                        setIsModalOpened(!isModalOpened);
                        setDataIsUpdated(true);
                        setIsAddModeOfInformationClicked(false);
                        setIsEdited(false);
                        editModeOfInformation(false);
                    }}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={() => {
                        setCanValidate(true);
                        setIsModalOpened(!isModalOpened);
                        editModeOfInformation(true);
                        setIsAddModeOfInformationClicked(false);
                        setIsEdited(false);
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
